export default "__VITE_ASSET__DyWTeE8e__"